export default "__VITE_ASSET__263096a2__"